import { ApiUtility } from "../Utilities/ApiUtility.axios";

class ProfileService {
  //   route = `${process.env.REACT_APP_API_BASE_URL}/Profile`;
  route = "V1/API/Profile";
  getUserProfile = () => ApiUtility.getResult(`${this.route}/GetUserProfile`);

  editUserProfile = (values: any) =>
    ApiUtility.post(`${this.route}/EditUserProfile`, values);

  uploadProfilePicture = (formData: any, headers: any) =>
    ApiUtility.post(`${this.route}/UploadProfilePicture`, formData, headers);
}
// eslint-disable-next-line new-parens
export default new ProfileService();
